import { findIndex, isEmpty } from 'lodash-es'
import moment from 'moment'

export const dateAndYearValidation = (
  showSaveError,
  tableData,
  rowData,
  year,
  date,
  startDate,
  endDate,
  startProjectDate,
  endProjectDate
) => {
  // validate start date is after start project date
  if (startProjectDate && moment(startProjectDate, 'DD/MM/YYYY') > moment(startDate)) {
    showSaveError(`startDate_${rowData.id}`, 'กรุณากรอกวันที่เริ่มงวด หลังวันที่เริ่มโครงการ')
    return true
  }

  // validate dateline is before end project date
  if (endProjectDate && moment(date) > moment(endProjectDate, 'DD/MM/YYYY')) {
    showSaveError(`date_${rowData.id}`, 'กรุณากรอกกำหนดส่งผลงาน ก่อนวันที่สิ้นสุดโครงการ')
    return true
  }

  // validate deadline is on the budget year
  // if (
  //   year != date.getFullYear() + 543 &&
  //   moment(date) < moment(`01/10/${year - 543 - 1}`, 'DD/MM/YYYY')
  // ) {
  //   showSaveError(`date_${rowData.id}`, 'กำหนดส่งผลงานไม่ตรงกับปีงบประมาณ')
  //   return true
  // }

  // validate end date is after start date
  if (moment(startDate) > moment(endDate)) {
    showSaveError(`endDate_${rowData.id}`, 'กรุณากรอกวันที่สิ้นสุดงวด หลังวันที่เริ่มงวด')
    return true
  }

  // validate end date is before deadline date
  // if (moment(endDate) > moment(date)) {
  //   showSaveError(`endDate_${rowData.id}`, 'กรุณากรอกวันที่สิ้นสุดงวด ก่อนกำหนดส่งผลงาน')
  //   return true
  // }

  // validate deadline in period start date to end date
  if (moment(date) < moment(startDate) || moment(date) > moment(endDate)) {
    showSaveError(`date_${rowData.id}`, 'กรุณากรอกกำหนดส่งผลงาน ภายในช่วงวันที่เริ่มงวด-วันที่สิ้นสุดงวด')
    return true
  }

  // validate deadline and year with other instalment
  if (isEmpty(tableData)) {
    return false
  }
  const dataIndex = findIndex(tableData, { id: rowData.id })
  const otherInstalment = tableData.filter((item) => item.id !== rowData.id)
  let isErrorYear = false
  let isErrorDate = false
  let isErrorStartDate = false
  let isErrorEndDate = false
  for (const [index, item] of otherInstalment.entries()) {
    if (dataIndex > index) {
      if (item.year > year && !isErrorYear) {
        showSaveError(`year_${rowData.id}`, 'กรุณากรอกปีงบประมาณ หลังปีในงวดก่อน')
        isErrorYear = true
      }

      if (moment(item.date, 'DD/MM/YYYY') > moment(date) && !isErrorDate) {
        showSaveError(`date_${rowData.id}`, 'กรุณากรอกกำหนดส่งผลงาน หลังวันในงวดก่อน')
        isErrorDate = true
      }

      if (moment(item.endDate, 'DD/MM/YYYY') > moment(startDate) && !isErrorStartDate) {
        showSaveError(
          `startDate_${rowData.id}`,
          'กรุณากรอกวันที่เริ่มงวด หลังวันที่สิ้นสุดงวดในงวดก่อน'
        )
        isErrorStartDate = true
      }
    } else {
      if (item.year < year && !isErrorYear && item.year) {
        showSaveError(`year_${rowData.id}`, 'กรุณากรอกปีงบประมาณ ก่อนปีในงวดหลัง')
        isErrorYear = true
      }

      if (moment(item.date, 'DD/MM/YYYY') < moment(date) && !isErrorDate) {
        showSaveError(`date_${rowData.id}`, 'กรุณากรอกกำหนดส่งผลงาน ก่อนวันในงวดหลัง')
        isErrorDate = true
      }

      if (moment(item.startDate, 'DD/MM/YYYY') < moment(endDate) && !isErrorStartDate) {
        showSaveError(
          `endDate_${rowData.id}`,
          'กรุณากรอกวันที่สิ้นสุดงวด ก่อนวันที่เริ่มงวดในงวดหลัง'
        )
        isErrorStartDate = true
      }
    }
  }
  if (isErrorYear || isErrorDate || isErrorStartDate) return true

  return false
}
